import { CustomTabPanel } from '@/erp/sale';
import { a11yProps, EstadoFactibilidadCorporativaENUM, EstadoPreventaEnum, sizeTab, useTabsFormOnly } from '@/shared';
import { SingleTableBoxScene } from '@/shared/components/ui';
import { Box, Tab, Tabs } from '@mui/material';
import React from 'react'
import TableGestionOportunidadComercial from '../../shared/table_gestion_oportunidad_comercial/TableGestionOportunidadComercial';
import TableGestionOportunidadComercialFactibilidad from '../../shared/table_gestion_oportunidad_comercial/TableGestionOportunidadComercialFactibilidad';

type Props = {}

const GestionOportunidadComercialPage = ({
    
}: Props) => {

    const {
        setValueTab,
        valueTab,
    } = useTabsFormOnly({initialTabValue: 0})

    return (
    <SingleTableBoxScene
    title={"Gestión Oportunidad Comercial"}
    visibleReport={true}
    >
    <Box
        sx={{
        bgcolor: "background.paper",
        maxWidth: sizeTab,
        paddingBottom: 2,
        }}
    >
        <Tabs
        value={valueTab}
        onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
        }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="scrollable force tabs preventa"
        >
        <Tab label={"Oportunidades Comerciales"} {...a11yProps(0)} />
        {/* <Tab label={'Preventas Aprobadas'} {...a11yProps(1)} /> */}
        <Tab label={"Factibilidades Corporativas"} {...a11yProps(1)} />
        </Tabs>
    </Box>
    <CustomTabPanel value={valueTab} index={0}>
        <TableGestionOportunidadComercial
        enableEditing={true}
        showCustomActionBtnSpace={true}
        estado_preventa={EstadoPreventaEnum.PRE_RECHAZADO}
        // aprueba_plan_personalizado={false}
        />
    </CustomTabPanel>
    <CustomTabPanel value={valueTab} index={1}>
        <TableGestionOportunidadComercialFactibilidad
        enableEditing={true}
        showCustomActionBtnSpace={true}
        estado_factibilidad={EstadoFactibilidadCorporativaENUM.PRE_RECHAZADO}
        // aprueba_plan_personalizado={true}
        />
    </CustomTabPanel>
    </SingleTableBoxScene>
  )
}

export default GestionOportunidadComercialPage